<template>
  <div
    class="inline-block whitespace-nowrap rounded px-2 py-1 text-[11px] font-medium capitalize leading-none text-white"
    :class="bgColor"
  >
    {{ displayLabel }}
  </div>
</template>

<script>
import { shipmentStatusColorMap } from '@/config/constants';

export default {
  name: 'VBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
  },
  computed: {
    bgColor() {
      return shipmentStatusColorMap[this.status] ?? 'bg-gray-500';
    },
    displayLabel() {
      if (this.label) {
        return this.label;
      }
      return this.status.replace(/_/g, ' ');
    },
  },
};
</script>
